import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Outlets from "./outlets/outlets";
import Customers from "./customers/customers";
import SalesOrderForm from "./salesOrder/salesOrderForm/salesOrderForm";
import SalesOrderList from "./salesOrder/salesOrderList";
import customerDetail from "./customers/customerDetail/customerDetail";
import SalesOrderDetail from "./salesOrder/salesOrderDetail/salesOrderDetail";
import QuotationList from "./quotation/quotationList";
import QuotationForm from "./quotation/quotationForm/quotationForm";
import QuotationDetail from "./quotation/quotationDetail/quotationDetail";
import ItemPackageList from "./item-package/itemPackageList";
import DiscountList from "./discount/DiscountList";
import SalesReturnList from ".//sales-return/salesReturnList";
import SalesReturnForm from "./sales-return/salesReturnForm/salesReturnForm";
import PosForm from "./pos/posForm/posForm";
import ItemsPriceForm from "./itemsPrice/ItemsPriceForm";
import OutletSetting from "./outlets/OutletSetting";
import SalesReport from "./sales-report/SalesReport";
import DiscountForm from "./discount/discount-form/DiscountForm";
import OnlineShop from "./olshop/OnlineShop";
import OnlineShopForm from "./olshop/onlineShopForm/OnlineShopForm";
import DiscountDetail from "./discount/discount-form/DiscountDetail";
import Licenses from "./licenses/Licenses";
import DeliveryOrderList from "./delivery-order/DeliveryOrderList";
import DeliveryOrderForm from "./delivery-order/DeliveryOrderForm";

export default function SalesPage() {
  return (
    <Switch>
      <Redirect exact={true} from="/sales" to="/sales/outlets" />
      <Route path="/sales/outlets" component={Outlets} />
      <Route path="/sales/outlet-setting/:outletID" component={OutletSetting} />
      <Route path="/sales/pos" component={PosForm} />
      <Route path="/sales/customers" component={Customers} />
      <Route
        path="/sales/customer-detail/:customerID"
        component={customerDetail}
      />
      <Route
        path="/sales/sales-order/sales-order-form"
        component={SalesOrderForm}
      />
      <Route
        path="/sales/sales-order/edit-sales-order/:salesOrderID"
        component={SalesOrderForm}
      />
      <Route
        path="/sales/sales-order/sales-order-detail/:salesOrderID"
        component={SalesOrderDetail}
      />
      <Route
        path="/sales/sales-order/sales-order-list"
        component={SalesOrderList}
      />
      <Route path="/sales/quotation/quotation-list" component={QuotationList} />
      <Route path="/sales/quotation/quotation-form" component={QuotationForm} />
      <Route
        path="/sales/quotation/edit-quotation/:quotationID"
        component={QuotationForm}
      />
      <Route
        path="/sales/quotation/quotation-detail/:quotationID"
        component={QuotationDetail}
      />
      <Route path="/sales/item-package" component={ItemPackageList} />
      <Route path="/sales/discount/discount-list" component={DiscountList} />
      <Route
        path="/sales/discount/discount-form/:discountID"
        component={DiscountForm}
      />

      <Route
        path="/sales/discount/discount-detail/:discountID"
        component={DiscountDetail}
      />

      <Route
        path="/sales/sales-return/sales-return-list"
        component={SalesReturnList}
      />
      <Route
        path="/sales/sales-return/sales-return-form"
        component={SalesReturnForm}
      />
      <Route path="/sales/items-price" component={ItemsPriceForm} />
      <Route path="/sales/delivery-order" component={DeliveryOrderList} />
      <Route path="/sales/delivery-order-form" component={DeliveryOrderForm} />
      <Route
        path="/sales/edit-delivery-order/:deliveryID"
        component={DeliveryOrderForm}
      />
      <Route path="/sales/sales-reports" component={SalesReport} />
      <Route path="/sales/online-shop" component={OnlineShop} />
      <Route path="/sales/online-shop-form" component={OnlineShopForm} />
      <Route path="/sales/licenses" component={Licenses} />
    </Switch>
  );
}
